import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getCommissionRuleList(params) {
  return request({
    url: URL.mdm.basicData.commissionRule,
    method: 'get',
    params
  })
}

export function saveCommissionRule(data) {
  return request({
    url: URL.mdm.basicData.commissionRule,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delCommissionRule(uuid) {
  return request({
    url: URL.mdm.basicData.commissionRule + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
